import { IUserEvent } from "@hulanbv/platformapp";
import { CrudService } from "nest-utilities-client";
import { environment } from "../constants/environment.constants";
import { httpService } from "./common/http.service";

class Service extends CrudService<IUserEvent> {
  constructor() {
    super([environment.apiUrl, "user-events"].join("/"), httpService);
  }
}

export const userEventService = new Service();
